import { render, staticRenderFns } from "./NotificationNav.vue?vue&type=template&id=36238bae&scoped=true"
import script from "./NotificationNav.vue?vue&type=script&lang=js"
export * from "./NotificationNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36238bae",
  null
  
)

export default component.exports